<template>
	<div v-if="chartOptions.series[0].data[0].name != ''" id="test2" :options="chartOptions" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="#0471A5"
            indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else id="test2" :options="chartOptions" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="#0471A5"
            indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import HighCharts from 'highcharts';
	import highchartsMore from 'highcharts/highcharts-more';
	highchartsMore(HighCharts);
  import axios from "axios";
	export default {
    props: {
      selectedTopic: null,
      selectedPeriode: null,
      selectedTopic2: null,
      statusFilter: null,
      nerPersonSearch: null,
      nerOrganizationSearch: null,
      isClickBubleOrg: null,
      isClickWord: null,
      resetcolorClicked: null,
      updateSocket: null
    },
		data() {
			return {
        isClickBuble: "",
        colorClicked: "",
				id: 'test2',
        dialog: false,
        kontenBerita: [],
        mediaBerita: [],
        MediatwitterShare: [],
        MediaYtShare: [],
        topic2: [],
        SetPerson: [],
        chart_data_sort: [],

        pageplay: 100,

				chartOptions: {
					chart: {
						type: 'packedbubble',
						height: '309px'
					},
					title: {
            text: null
          },
					tooltip: {
						enabled: false
					},
					legend: {
						enabled: false
					},
					credits: {
						enabled: false
					},
          series: [
            {
              data: [{
                value: 0,
                name: ''
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'gray'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'pink'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'yellow'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'green'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'purple'
              }]
            },
          ],

          plotOptions: {
            packedbubble: {
              minSize: '40%',
              maxSize: '120%',
              zMin: 0,
              zMax: 1000,
              layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.02
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}',
                useHTML: true,
                style: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  width: 100,
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                },
              }
            }
          },
				},
			}
		},
		mounted() {
			// this.option.series = this.seriesData;
      HighCharts.chart(this.id, this.chartOptions);
    },
		updated() {
			HighCharts.chart(this.id, this.chartOptions);
		},
    methods: {
      onClickBuble(event) {
        this.isClickBuble = event.point.name;
        console.log(event.point.color);
        this.colorClicked = event.point.color;
        this.$emit('clicked', this.isClickBuble);
      },
      async loadKontenBerita() {
        this.mediaBerita = [];
        this.MediatwitterShare = [];
        this.MediaYtShare = [];
        HighCharts.chart(this.id, this.chartOptions);
        if (this.updateSocket == false) {
          this.dialog = true;
        }
        try {
          const getStoreValue = (key, defaultValue = "") => {
            return this.$store[key] || defaultValue;
          };

          // const sentiment_search = getStoreValue("sentiment_glob");
          // const ner_person_search = getStoreValue("ner_person_glob");
          // const ner_organization_search = getStoreValue("ner_organization_glob");
          const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");

          const authToken = localStorage.getItem('token_app');
          if (!authToken) {
            throw new Error("Auth token not found");
          }

          const data1 = await axios.post(
            `influencing-chart?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const data = data1.data;

          if (this.isClickBuble == '' && data.data_buble.length != 0) {
            this.SetPerson = data.data_buble[0];

            this.chart_data_sort = [];
            for (let x = 0; x < this.SetPerson.length; x++) {
              this.chart_data_sort.push({
                'name_person' : this.SetPerson[x].name,
                'name_person_value' : this.SetPerson[x].totalNews
              })
            }
            this.chart_data_sort.sort(function(a,b) { // sort desc value
              return (b.name_person_value) - (a.name_person_value);
            });
            for (let i = 0; i < 6; i++) {
              this.chartOptions.series[i].data[0].name = "";
              this.chartOptions.series[i].data[0].value = 0;
            }
            if (this.chart_data_sort.length == 0) {
              for (let i = 0; i < 6; i++) {
                this.chartOptions.series[i].data[0].name = "";
                this.chartOptions.series[i].data[0].value = 0;
              }
            }
          }
          if (this.chart_data_sort.length != 0) {
            for (let x = 0; x < this.chart_data_sort.length; x++) {
              if (x < 6) {
                this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_person;
                this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_person_value);
              }
            }
          }
          if (data.data_buble.length == 0) {
            for (let i = 0; i < 6; i++) {
              this.chartOptions.series[i].data[0].name = "";
              this.chartOptions.series[i].data[0].value = 0;
            }
          }
          if (this.colorClicked != "") {
            this.chartOptions.series[0].data[0].color = "#013b73";
            this.chartOptions.series[1].data[0].color = "#d4d4fa";
            this.chartOptions.series[2].data[0].color = "#ffcfee";
            this.chartOptions.series[3].data[0].color = "#fcf8b8";
            this.chartOptions.series[4].data[0].color = "#bdfcb6";
            this.chartOptions.series[5].data[0].color = "#e8b3fc";
          }
          if (this.colorClicked != "" && this.isClickBuble != this.chartOptions.series[0].data[0].name) {
            for (let index = 0; index < this.chartOptions.series.length; index++) {
              if (this.chartOptions.series[index].data[0].name == this.isClickBuble) {
                this.chartOptions.series[index].data[0].color = "#013b73";
                this.chartOptions.series[0].data[0].color = '#bbdcfc';
              }
            }
          }
          if (this.resetcolorClicked == true) {
            this.chartOptions.series[0].data[0].color = "#7cb5ec";
            this.chartOptions.series[1].data[0].color = "gray";
            this.chartOptions.series[2].data[0].color = "pink";
            this.chartOptions.series[3].data[0].color = "yellow";
            this.chartOptions.series[4].data[0].color = "green";
            this.chartOptions.series[5].data[0].color = "purple";
          }
          this.dialog = false;
          this.updateSocket = false;
        } catch(e) {
          this.dialog = true;
          console.log('error');
          console.log(e);
        }
      },
      // async loadSentimentanalysisBerita() {
      //   this.mediaBerita = [];
      //   this.dialog = true;
      //   setTimeout(() => {
      //     this.dialog = false;
      //   }, 1000);
      //   try {
      //     for (let i = 0; i < this.kontenBerita.length; i++) {
      //       if (this.kontenBerita[i].source == 'berita') {
      //         this.mediaBerita.push(this.kontenBerita[i]);
      //       }
      //     }
      //     const person = [];
      //     const person2 = [];
      //     this.mediaBerita.forEach((element) => {
      //       if (element["ner_person"] != '' && element["ner_person"] != null) {
      //         person.push(element["ner_person"]);
      //         person2.push(element["ner_person"]);
      //       }
      //     });
      //     const SetttPerson = [];
      //     const SetttPerson2 = [];
      //     for (let i = 0; i < person.length; i++) {
      //       SetttPerson.push(person[i].at(-0));
      //       SetttPerson2.push(person2[i].at(-1));
      //     }

      //     const Setperson = [...new Set(SetttPerson)];
      //     const Setperson2 = [...new Set(SetttPerson2)];
      //     const Setperson3 = Setperson.concat(Setperson2);

      //     this.SetPerson = [...new Set(Setperson3)];

      //     this.chart_data_sort = [];
      //     for (let x = 0; x < this.SetPerson.length; x++) {
      //       var jum1 = 0;
      //       for (let i = 0; i < this.mediaBerita.length; i++) {
      //         if (this.mediaBerita[i].ner_person != null) { //tambahan karna data ada yang null
      //           if (this.mediaBerita[i].ner_person[0] != '' && this.mediaBerita[i].ner_person[0] != null) { //tambahan karna data ada yang null
      //             if (this.mediaBerita[i].ner_person[0] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //           if (this.mediaBerita[i].ner_person[1] != '' && this.mediaBerita[i].ner_person[1] != null) { //tambahan karna data ada yang null
      //             if (this.mediaBerita[i].ner_person[1] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //         }
      //       }

      //       this.chart_data_sort.push({
      //         'name_person' : this.SetPerson[x],
      //         'name_person_value' : jum1
      //       })
      //     }
      //     this.chart_data_sort.sort(function(a,b) { // sort desc value
      //       return (b.name_person_value) - (a.name_person_value);
      //     });
      //     if (this.SetPerson.length == 0) {
      //       for (let i = 0; i < 6; i++) {
      //         this.chartOptions.series[i].data[0].name = "";
      //         this.chartOptions.series[i].data[0].value = 0;
      //       }
      //     }
      //     if (this.SetPerson.length != 0) {
      //       for (let x = 0; x < this.chart_data_sort.length; x++) {
      //         if (x < 6) {
      //           this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_person;
      //           this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_person_value);
      //         }
      //       }
      //     }
      //   } catch (e) {
      //     console.log('error');
      //   }
      // },
      // async loadSentimentTweet() {
      //   this.MediatwitterShare = [];
      //   HighCharts.chart(this.id, this.chartOptions);
      //   this.dialog = true;
      //   setTimeout(() => {
      //     this.dialog = false;
      //   }, 1000);
      //   try {
      //     for (let i = 0; i < this.kontenBerita.length; i++) {
      //       if (this.kontenBerita[i].source == 'twitter') {
      //         this.MediatwitterShare.push(this.kontenBerita[i]);
      //       }
      //     }
      //     const person = [];
      //     const person2 = [];
      //     this.MediatwitterShare.forEach((element) => {
      //       if (element["ner_person"] != '' && element["ner_person"] != null) {
      //         person.push(element["ner_person"]);
      //         person2.push(element["ner_person"]);
      //       }
      //     });
      //     const SetttPerson = [];
      //     const SetttPerson2 = [];
      //     for (let i = 0; i < person.length; i++) {
      //       SetttPerson.push(person[i].at(-0));
      //       SetttPerson2.push(person2[i].at(-1));
      //     }

      //     const Setperson = [...new Set(SetttPerson)];
      //     const Setperson2 = [...new Set(SetttPerson2)];
      //     const Setperson3 = Setperson.concat(Setperson2);

      //     this.SetPerson = [...new Set(Setperson3)];

      //     this.chart_data_sort = [];
      //     for (let x = 0; x < this.SetPerson.length; x++) {
      //       var jum1 = 0;
      //       for (let i = 0; i < this.MediatwitterShare.length; i++) {
      //         if (this.MediatwitterShare[i].ner_person != null) { //tambahan karna data ada yang null
      //           if (this.MediatwitterShare[i].ner_person[0] != '' && this.MediatwitterShare[i].ner_person[0] != null) { //tambahan karna data ada yang null
      //             if (this.MediatwitterShare[i].ner_person[0] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //           if (this.MediatwitterShare[i].ner_person[1] != '' && this.MediatwitterShare[i].ner_person[1] != null) { //tambahan karna data ada yang null
      //             if (this.MediatwitterShare[i].ner_person[1] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //         }
      //       }

      //       this.chart_data_sort.push({
      //         'name_person' : this.SetPerson[x],
      //         'name_person_value' : jum1
      //       })
      //     }
      //     this.chart_data_sort.sort(function(a,b) { // sort desc value
      //       return (b.name_person_value) - (a.name_person_value);
      //     });
      //     if (this.SetPerson.length == 0) {
      //       for (let i = 0; i < 6; i++) {
      //         this.chartOptions.series[i].data[0].name = "";
      //         this.chartOptions.series[i].data[0].value = 0;
      //       }
      //     }
      //     if (this.SetPerson.length != 0) {
      //       for (let x = 0; x < this.chart_data_sort.length; x++) {
      //         if (x < 6) {
      //           this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_person;
      //           this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_person_value);
      //         }
      //       }
      //     }
      //   } catch (e) {
      //     console.log('error');
      //   }
      // },
      // async loadSentimentYt() {
      //   this.MediaYtShare = [];
      //   HighCharts.chart(this.id, this.chartOptions);
      //   this.dialog = true;
      //   setTimeout(() => {
      //     this.dialog = false;
      //   }, 1000);
      //   try {
      //     for (let i = 0; i < this.kontenBerita.length; i++) {
      //       if (this.kontenBerita[i].source == 'youtube') {
      //         this.MediaYtShare.push(this.kontenBerita[i]);
      //       }
      //     }
      //     const person = [];
      //     const person2 = [];
      //     this.MediaYtShare.forEach((element) => {
      //       if (element["ner_person"] != '' && element["ner_person"] != null) {
      //         person.push(element["ner_person"]);
      //         person2.push(element["ner_person"]);
      //       }
      //     });
      //     const SetttPerson = [];
      //     const SetttPerson2 = [];
      //     for (let i = 0; i < person.length; i++) {
      //       SetttPerson.push(person[i].at(-0));
      //       SetttPerson2.push(person2[i].at(-1));
      //     }

      //     const Setperson = [...new Set(SetttPerson)];
      //     const Setperson2 = [...new Set(SetttPerson2)];
      //     const Setperson3 = Setperson.concat(Setperson2);

      //     this.SetPerson = [...new Set(Setperson3)];

      //     this.chart_data_sort = [];
      //     for (let x = 0; x < this.SetPerson.length; x++) {
      //       var jum1 = 0;
      //       for (let i = 0; i < this.MediaYtShare.length; i++) {
      //         if (this.MediaYtShare[i].ner_person != null) { //tambahan karna data ada yang null
      //           if (this.MediaYtShare[i].ner_person[0] != '' && this.MediaYtShare[i].ner_person[0] != null) { //tambahan karna data ada yang null
      //             if (this.MediaYtShare[i].ner_person[0] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //           if (this.MediaYtShare[i].ner_person[1] != '' && this.MediaYtShare[i].ner_person[1] != null) { //tambahan karna data ada yang null
      //             if (this.MediaYtShare[i].ner_person[1] == this.SetPerson[x]) {
      //               jum1++;
      //             }
      //           }
      //         }
      //       }

      //       this.chart_data_sort.push({
      //         'name_person' : this.SetPerson[x],
      //         'name_person_value' : jum1
      //       })
      //     }
      //     this.chart_data_sort.sort(function(a,b) { // sort desc value
      //       return (b.name_person_value) - (a.name_person_value);
      //     });
      //     if (this.SetPerson.length == 0) {
      //       for (let i = 0; i < 6; i++) {
      //         this.chartOptions.series[i].data[0].name = "";
      //         this.chartOptions.series[i].data[0].value = 0;
      //       }
      //     }
      //     if (this.SetPerson.length != 0) {
      //       for (let x = 0; x < this.chart_data_sort.length; x++) {
      //         if (x < 6) {
      //           this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_person;
      //           this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_person_value);
      //         }
      //       }
      //     }
      //   } catch (e) {
      //     console.log('error');
      //   }
      // },
    },
	};
</script>